import { gatedContentStore } from '@/stores/gatedContent';
import { formOptions } from '@tanstack/react-form';

export const contactFormOptions = formOptions({
  defaultValues: {
    /* ===== Form Fields (non-"zh") ===== */
    first_name: '',
    last_name: '',
    email: '',
    company: '',
    country: '',
    state: '',
    // This is a dummy field to store the selected value from the "How Can We Help?" dropdown. On form submission, the selected value is used to set the `xxxx_tf` fields below using the `FORM_HELP_OVERRIDE_MAP` object. This workaround is required because multiple option items control the value of the `manage_tf` which, when set directly, results in "duplicate key" errors thrown by React.
    howCanWeHelp: '',

    // Dummy field to store the selected value from the "Support" dropdown which will be used to set the above fields to true/false depending on the selected option. This is required because multiple options require the value of 'Managed Solution' be set which React doesn't like.
    supportDummy: '',
    /* ===== "How Did You Hear About Us?" input ===== */
    How_Did_You_Hear_About_Us: '',
    Opt_In: false,
    Additional_Information: '',
    phone: '',

    // "zh" fields
    Name: '',
    job_title: '',
    industry: '',
    Employee_Size: '',
    serviceOfInterest: '',
  },
});

const getGatedFormDefaultValues = (): {
  company: string;
  country: string;
  email: string;
  first_name: string;
  handler_key: string;
  conversion_entry_page_full_most_recent: string;
  last_name: string;
  Name: string;
  phone: string;
  state: string;
  Opt_In: boolean;
} => {
  const currentStore = gatedContentStore.get();
  return {
    company: currentStore.formSubmissionData?.company || '',
    country: currentStore.formSubmissionData?.country || '',
    email: currentStore.formSubmissionData?.email || '',
    first_name: currentStore.formSubmissionData?.first_name || '',
    handler_key: 'form-submission',
    conversion_entry_page_full_most_recent: '',
    last_name: currentStore.formSubmissionData?.last_name || '',
    // "zh" name field
    Name: currentStore.formSubmissionData?.Name || '',
    phone: currentStore.formSubmissionData?.phone || '',
    state: currentStore.formSubmissionData?.state || '',
    Opt_In: false,
  };
};
export const gatedContentFormOptions = formOptions({
  defaultValues: getGatedFormDefaultValues(),
});
